import { render, staticRenderFns } from "./TextLineThrough.vue?vue&type=template&id=7c01e71c&scoped=true"
var script = {}
import style0 from "./TextLineThrough.vue?vue&type=style&index=0&id=7c01e71c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c01e71c",
  null
  
)

export default component.exports